import { Trans } from '@lingui/react/macro';
import { ChevronDown } from '@untitledui/icons/ChevronDown';
import { ChevronUp } from '@untitledui/icons/ChevronUp';
import { useState } from 'react';

interface WhatToExpectProps {
  defaultExpanded?: boolean;
}

export function WhatToExpect({ defaultExpanded = true }: WhatToExpectProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="rounded-2xl bg-utility-purple-50 py-6">
      <div className="px-6">
        {/* Header */}
        <button
          type="button"
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
          className="flex w-full cursor-pointer items-center justify-between"
          aria-expanded={isExpanded}
          aria-controls="what-to-expect-content"
        >
          <h2 className="text-md font-semibold text-primary">
            <Trans>What to expect</Trans>
          </h2>
          {isExpanded ? (
            <ChevronUp className="size-6 text-primary" />
          ) : (
            <ChevronDown className="size-6 text-primary" />
          )}
        </button>

        {/* Content */}
        {isExpanded && (
          <div id="what-to-expect-content" className="mt-6 space-y-0">
            {/* Step 1 */}
            <div className="flex gap-5">
              {/* Icon and Connector */}
              <div className="flex flex-col items-center">
                <div className="flex size-12 items-center justify-center text-display-sm">
                  🤔
                </div>
                <div className="my-1 w-0.5 flex-1 bg-secondary" />
              </div>

              {/* Content */}
              <div className="pt-1 pb-6">
                <p className="text-sm font-semibold text-primary">
                  <Trans>
                    Apply and answer screener questions to see if you qualify.
                  </Trans>
                </p>
                <p className="mt-1 text-sm text-secondary">
                  <Trans>
                    The researcher will then review your application and send an
                    invite if you're selected.
                  </Trans>
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex gap-5">
              {/* Icon */}
              <div className="flex flex-col items-center">
                <div className="flex size-12 items-center justify-center text-display-sm">
                  🥳
                </div>
              </div>

              {/* Content */}
              <div className="pt-1">
                <p className="text-sm font-semibold text-primary">
                  <Trans>Complete a project and get paid</Trans>
                </p>
                <p className="mt-1 text-sm text-secondary">
                  <Trans>
                    Once approved, take part in the project and receive payment
                    directly for your time and insights.
                  </Trans>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
